invitations:
  toast:
    progress: Please wait...
    success: Invitation accepted!
autoUpdate:
  ready: ShuttlerockCloud is ready to update!
  updateNow: Update now
navigation:
  accountSettings: Account Settings
  home: Home
  admin: Admin
  brands: Brands
  brandProfile: Brand Profile
  clients: Clients
  contactUs: Contact Us
  newOrder: New Project
  preferences: Preferences
  profile: Profile
  projects: Projects
  projectShortcuts:
    all: All
    draft: Draft
    active: Active
    approved: Approved
  creativeLibrary: Creative library
  signOut: Sign Out
  support: Help Center
  users: Users
  accountInsights: Account Insights
preferences:
  title: Preferences
  theme:
    title: Theme
    preset:
      title: Shuttlerock Preset
      description: Pages will display in light mode by default. Some pages predefined by Shuttlerock will display in dark mode.
    system:
      title: Follow System
      description: Pages will display in either light or dark mode depending on your OS preference.
    light:
      title: Always Light
      description: All pages will always display in light mode.
    dark:
      title: Always Dark
      description: All pages will always display in dark mode.
  language:
    label: Select language
  privacy:
    title: Privacy
    essential:
      title: Essential services
      description: Required for Shuttlerock to work. This includes sign-in, account security, saving your settings and error reports that help us fix problems.
      status: Always on
    analytics:
      title: Product analytics
      description: Helps us understand which features are used so we can improve Shuttlerock. We don't use this for advertising.
      learnMore: Learn more
errorPage:
  default:
    title: Something went wrong
    defaultMessage: Please try again, or get in touch with our support team if you need a hand to solve this issue.
    button:
      primary: Try Again
      secondary: Contact Support
creativeLibrary:
  error:
    conceptDetails: Failed to load concept details.
